export const PLATFORM_LABELS = {
  'x-verdict': 'X-Verdict',
  orcaa: 'Orcaa',
  proba: 'Proba Analytics',
  engagenet: 'EngageNet',
  workflow: 'Proba Workflows',
  complyon: 'ComplyOn',
  complyon_onboard: 'OnboardID',
};

export const PLATFORM_NAME_TO_KEY = Object.freeze(Object.assign(Object.create(null), {
  'orcaa ai': 'orcaa',
  orcaa: 'orcaa',
  'proba analytics': 'proba',
  proba: 'proba',
  analytics: 'proba',
  complyon: 'complyon',
  engagenet: 'engagenet',
  'ic workbook': 'engagenet',
  'x verdict': 'x-verdict',
  xverdict: 'x-verdict',
  'proba workflows': 'workflow',
  workflows: 'workflow',
  'complyon onboard': 'complyon_onboard',
  complyon_onboard: 'complyon_onboard',
}));

export const SUPER_ADMIN_APP_KEYS = [
  'orcaa',
  'proba',
  'x-verdict',
  'engagenet',
  'workflow',
  'complyon',
  'complyon_onboard',
];

export const PLATFORM_ENDPOINTS = {
  'x-verdict': '/aic_one_api/system_management/launch_xverdict/',
  orcaa: '/aic_one_api/system_management/launch_orcaa/',
  proba: '/aic_one_api/system_management/launch_proba/',
  engagenet: '/aic_one_api/system_management/launch_engagenet/',
  workflow: '/aic_one_api/system_management/launch_proba_workflow/',
  complyon: '/aic_one_api/system_management/launch_complyon/',
  complyon_onboard: '/aic_one_api/system_management/launch_complyon_onboard/',
};

export const PLAYGROUND_PLATFORM_ALIASES = {
  'x-verdict': ['x-verdict', 'x verdict', 'xverdict'],
  orcaa: ['orcaa', 'orcaa.ai'],
  proba: ['proba', 'proba analytics'],
  engagenet: ['engagenet', 'engage net', 'ic workbook'],
  workflow: ['workflow', 'workflows', 'proba workflows', 'proba-workflows'],
  complyon: ['complyon', 'comply on'],
};
